import { render, staticRenderFns } from "./FormConsultaPesquisaProtesto.vue?vue&type=template&id=2fe4ef95&scoped=true"
import script from "./FormConsultaPesquisaProtesto.vue?vue&type=script&lang=js"
export * from "./FormConsultaPesquisaProtesto.vue?vue&type=script&lang=js"
import style0 from "./FormConsultaPesquisaProtesto.vue?vue&type=style&index=0&id=2fe4ef95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4ef95",
  null
  
)

export default component.exports